// extracted by mini-css-extract-plugin
export default {"tooltip":"Ao-z","sharingV2":"Bo-z","sharingIconsV2":"Co-z","links":"Do-z","link":"Eo-z","facebookV2":"Fo-z","twitterV2":"Go-z","pinterestV2":"Ho-z"};